import { z } from 'zod';
import { BigdesDefinitionSchema } from './bigdes-base.schema.js';

export const ProcessingPurposeSchema = BigdesDefinitionSchema.extend({});
export const CreateProcessingPurposeSchema = ProcessingPurposeSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateProcessingPurposeSchema = ProcessingPurposeSchema.partial();
